// Twilio conversation states: initializing | active | inactive | closed.
// Twilio is the source of truth for the state, so we render the badge from `state.current`.
// `active`/`closed` reuse ids already defined in utils/static/statuses; `inactive`/`initializing`
// use non-mapped ids so <Status> takes the provided label/category (keeping the global `inactive`
// status —used in other views as an error/red badge— untouched).
export const getConversationStatusProps = (stateCurrent) => {
    switch (stateCurrent) {
        case "active":
            return { id: "active" };
        case "closed":
            return { id: "closed", withIcon: true };
        case "inactive":
            return { id: "conversationInactive", label: "Inactive", category: "warning" };
        case "initializing":
            return { id: "conversationInitializing", label: "Initializing", category: "info" };
        default:
            return { id: stateCurrent, label: stateCurrent, category: "default" };
    }
};

// Phone number bound to an SMS conversation. Twilio exposes it synchronously on the conversation
// object as `bindings.sms.address` (available for closed conversations too). Empty for non-SMS chats.
export const getConversationPhoneNumber = (conversation) => {
    return conversation?.bindings?.sms?.address || "";
};

export const getAttributes = (conversation) => {
    if (!conversation) {
        return {};
    }
    const { attributes } = conversation;
    let attrs = attributes;
    while (typeof attrs === "string") {
        attrs = JSON.parse(attributes);
    }
    return attrs;
};

// Example:
// Argument = "+18432557147"
// Returns = "+1 843 255 7147"
export const formatPhoneNumber = (unformattedPhoneNumber) => {
    const withoutPrefix = unformattedPhoneNumber.substring(unformattedPhoneNumber.length - 10, unformattedPhoneNumber.length);
    const firstPart = withoutPrefix.substring(0, 3);
    const secondPart = withoutPrefix.substring(3, 6);
    const thirdPart = withoutPrefix.substring(6, 10);
    return unformattedPhoneNumber.replace(withoutPrefix, ` ${firstPart} ${secondPart} ${thirdPart}`);
};
